<template>
  <div v-if="path" class="row">
    <!-- fluidSelectRow -->

    <div v-if="noLabel === false" class="col-4">
      <label class="label-unidato geometrySelectLabel">{{ uniTranslation("S572") }}</label>
    </div>
    <div v-if="noLabel === false" class="col-8">
      <el-select v-model="selectedGeometry" class="geometrySelect" placeholder="..." filterable>
        <el-option
          v-for="item in geometryList"
          :key="item.id"
          :label="uniTranslation(item.descrizione)"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>
    <div v-if="noLabel === true" class="col-12">
      <el-select v-model="selectedGeometry" placeholder="..." filterable class="geometrySelect">
        <el-option
          v-for="item in geometryList"
          :key="item.id"
          :label="uniTranslation(item.descrizione)"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Select, Option } from "element-ui";
import jsonHelper from "../../shared/jsonHelper";
import conversionService from "../../services/backend/conversionService";

export default {
  name: "PheGeometryPicker",
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    },
    noLabel: Boolean
  },
  data() {
    return {
      geometryList: [],
      geometryListFromApi: {},
      selectedGeometry: "",
      path: "",
      unsubscribes: [],
      mixed: []
    };
  },
  computed: {
    ...mapGetters("_translationModule", ["currentLanguage", "languages"]),
    ...mapGetters("_prjModule", ["isSaldobrasata", "projects"])
  },
  watch: {
    selectedGeometry: function(nv /*, ov*/) {
      if (nv != null && nv != undefined) {
        var idg = parseInt(nv);
        this.changeProperty({
          path: this.path + ".geometry.id",
          value: idg
        });

        this.setBloccoCalcoloMethod(false);

        //---- SISTEMO E CONTROLLO IL NUMERO DI PIASTRE ------
        var that = this;
        var guid = that.geometryListFromApi[idg].plateGeometryGUID + "";
        var steps = that.geometryListFromApi[idg].stepListaPiastre.replaceAll(" ", "").split(",");
        that.setStepListAction(steps);

        var indexMixed = that.mixed.indexOf(that.selectedGeometry);
        var isMixes = indexMixed != -1;
        that.setMixed(isMixes);

        if (isMixes) {
          var npMin = that.geometryListFromApi[idg].npMin;
          var npMax = that.geometryListFromApi[idg].npMax;

          that.setMinPlates(npMin);
          that.setMaxPlates(npMax);
        }
        that.setGeometry(that.geometryListFromApi[idg]);

        that.getPressuresGuidByGeomGuidAction(guid).then(data => {
          if (data.length > 0) {
            that.setAvaiablePressAction(data);
          } else {
            that.setBloccoCalcoloMethod(true);
          }
        });

        conversionService
          .validateUsrValue({
            unidato: jsonHelper.getProperty(
              that.projects,
              that.parentPath + ".bottom.numberOfPlates"
            ),
            project: this.GetSimplexProject(),
            path: ".numberOfPlates"
          })
          .then(function(data) {
            that.changeProperty({
              path: that.parentPath + ".bottom.numberOfPlates.input",
              value: data.input
            });
          });

        //----------------------------------------------------
      }
    }
  },
  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },
  mounted: function() {
    var that = this;
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;

    that.updateGeometries();
  },
  methods: {
    ...mapActions("_geometryModule", [
      "getGeometryAction",
      "setStepListAction",
      "getMixedGeometryListAction",
      "setMixed",
      "setMinPlates",
      "setMaxPlates",
      "setLowPlates",
      "setHighPlates",
      "setGeometry"
    ]),
    ...mapActions("_prjModule", ["changeProperty", "setBloccoCalcolo"]),
    ...mapActions("_pricesModule", ["getPressuresGuidByGeomGuidAction"]),
    ...mapActions("_pressuresModule", ["setAvaiablePressAction"]),

    reloadGeometry() {
      var that = this;
      that.selectedGeometry = that.getGeometryId(); //jsonHelper.getProperty(that.projects, that.path + ".geometry.id");
    },

    GetSimplexProject() {
      var prjName = this.path.substring(0, this.path.indexOf("."));
      var P = this.projects[prjName];
      var deepClone_P = JSON.parse(JSON.stringify(P));
      deepClone_P.innerProject = null;
      deepClone_P.selectionOutput.selectionOutput = [];
      deepClone_P.results = [];
      return deepClone_P;
    },
    getGeometryId() {
      var that = this;
      var def = jsonHelper.getProperty(that.projects, that.path + ".geometry.id");
      var ret = 1;
      var i = 0;
      that.geometryList.forEach(el => {
        if (def == el.id) {
          ret = i; //el.id;
        }
        i++;
      });
      if (that.geometryList[ret] == undefined) {
        //console.log("UNDEFINED = " + that.geometryList[0].id);
        return that.geometryList[0].id;
      }
      //console.log(that.geometryList[ret].id);
      return that.geometryList[ret].id;
    },
    updateGeometries: function() {
      var that = this;
      var modality = jsonHelper.getProperty(that.projects, that.parentPath + ".modality");
      that.geometryList = [];

      var payload = {};
      payload.modality = modality;
      payload.isSaldobrasata = that.isSaldobrasata;

      that.getMixedGeometryListAction(payload).then(data => {
        that.mixed = data;
      });

      that.getGeometryAction(payload).then(function(data) {
        data.forEach(element => {
          that.geometryList.push({
            descrizione: element.descrizione,
            id: element.idGeometriaPiastra
          });
          //======
          //MARCO DC 03/05/2022
          that.geometryListFromApi[element.idGeometriaPiastra] = element;

          //======
        });
        that.selectedGeometry = that.getGeometryId(); //jsonHelper.getProperty(that.projects, that.path + ".geometry.id");
      });
    },
    setBloccoCalcoloMethod(payload) {
      this.setBloccoCalcolo(payload);
    }
  }
};
</script>

<style lang="scss">
.geometrySelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.geometrySelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px;
    }
  }
}

.geometrySelectRow {
  margin-right: 0px;
  margin-left: 0px;
  .col-3 {
    padding-right: 0px;
    padding-left: 0px;
  }
  .col-9 {
    padding-right: 0px;
    padding-left: 0px;
  }
}
</style>
